import { optionSchema } from '@/common/schemas/option.schema';
import { maintenanceRequiredDocumentSchema, maintenanceSpecificationSchema } from '@/features/establishmentLeadsFunnel/schemas/update.schema';
import { z } from 'zod';

export const updateEstablishmentCompanyMaintenanceModelsSchema = z.object({
  maintenance_infrastructures: z.array(optionSchema).optional().nullable(),
  maintenance_specialty: z.object({
    id: z.string().optional().nullable(),
    system_part_id: z.string().optional().nullable(),
    action_id: z.string().optional().nullable(),
  }).optional().nullable(),
  maintenance_technical_professionals: z.array(optionSchema).optional().nullable(),
  maintenance_required_documents_attributes: z.array(maintenanceRequiredDocumentSchema).optional(),
  maintenance_specifications_attributes: z.array(maintenanceSpecificationSchema).optional(),
});

export type UpdateEstablishmentCompanyMaintenanceModelsValidationSchema = z.infer<typeof updateEstablishmentCompanyMaintenanceModelsSchema>;
